import { render } from "./BlackFriday20.vue?vue&type=template&id=adba99b2&scoped=true"
import script from "./BlackFriday20.vue?vue&type=script&lang=js"
export * from "./BlackFriday20.vue?vue&type=script&lang=js"

import "./BlackFriday20.vue?vue&type=style&index=0&id=adba99b2&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adba99b2"]])

export default __exports__